import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { BulkActionType } from '../bulkActions.types';
import { SearchQueryWithoutPagination } from '../createBulkActionJobByFiltersCommand';

const ENDPOINT = `${APIConfiguration.search}bulkActions/workflows`;

export interface WorkflowForBulkActionDto {
  workflowName?: string;
}

export interface GetWorkflowsForBulkActionArgs {
  actionType: BulkActionType;
  itemFilters: SearchQueryWithoutPagination;
}

export async function getWorkflowsForBulkActionQuery({
  actionType,
  itemFilters,
}: GetWorkflowsForBulkActionArgs): Promise<
  BackResponse<WorkflowForBulkActionDto[]> | BackResponseFailure
> {
  try {
    return await apiCall<BackResponse<WorkflowForBulkActionDto[]>>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        actionType,
        itemFilters,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
